// Public, in-memory practice. No grading requests or persisted answers.
export const verbFormMatches = (answer, expected) => {
  const normalized = answer.trim().toLowerCase();
  return normalized === expected.toLowerCase() || expected.toLowerCase().split("/").includes(normalized);
};

export const selectVerbs = (verbs, level, random = Math.random) => {
  const pool = verbs.filter(verb => level === "all" || verb.level === level);
  for (let i = pool.length - 1; i > 0; i -= 1) {
    const j = Math.floor(random() * (i + 1));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }
  return pool.slice(0, 10);
};

const initIrregularVerbs = () => {
  document.querySelectorAll("[data-irregular-verbs]").forEach(root => {
    if (root.dataset.verbsInitialized) return;
    root.dataset.verbsInitialized = "true";
    const verbs = JSON.parse(root.dataset.verbs);
    const find = name => root.querySelector(`[data-verb-${name}]`);
    const past = find("past");
    const participle = find("participle");
    const check = find("form").querySelector("button");
    let level = "all";
    let round = [];
    let index = 0;
    let missed = [];
    let checked = false;

    const show = () => {
      checked = false;
      const verb = round[index];
      find("progress").textContent = `${index + 1} / ${round.length}`;
      find("base").textContent = verb.base;
      find("meaning").textContent = verb.meaning;
      past.value = "";
      participle.value = "";
      past.disabled = false;
      participle.disabled = false;
      check.disabled = false;
      find("feedback").textContent = "";
      find("next").hidden = true;
      past.focus();
    };
    const start = () => {
      round = selectVerbs(verbs, level);
      index = 0;
      missed = [];
      find("start").hidden = true;
      find("results").hidden = true;
      find("round").hidden = false;
      show();
    };
    find("print").addEventListener("click", () => window.print());
    find("start").hidden = false;
    find("start").addEventListener("click", start);
    find("again").addEventListener("click", start);
    root.querySelectorAll("[data-verb-filter]").forEach(button => {
      button.addEventListener("click", () => {
        level = button.dataset.verbFilter;
        root.querySelectorAll("[data-verb-filter]").forEach(chip => {
          chip.setAttribute("aria-pressed", String(chip === button));
        });
        root.querySelectorAll("[data-verb-row]").forEach(row => {
          row.hidden = level !== "all" && row.dataset.level !== level;
        });
        // A changed level starts a fresh quiz, without silently mixing pools.
        find("start").hidden = false;
        find("round").hidden = true;
        find("results").hidden = true;
      });
    });
    find("form").addEventListener("submit", event => {
      event.preventDefault();
      if (checked || !past.value.trim() || !participle.value.trim()) return;
      checked = true;
      const verb = round[index];
      const pastCorrect = verbFormMatches(past.value, verb.past);
      const participleCorrect = verbFormMatches(participle.value, verb.participle);
      if (!pastCorrect || !participleCorrect) missed.push(verb);
      find("feedback").textContent = `${pastCorrect ? "✓" : "✗"} ${verb.past} / ${participleCorrect ? "✓" : "✗"} ${verb.participle}`;
      past.disabled = true;
      participle.disabled = true;
      check.disabled = true;
      find("next").hidden = false;
      find("next").focus();
    });
    find("next").addEventListener("click", () => {
      if (!checked) return;
      index += 1;
      if (index < round.length) { show(); return; }
      checked = false;
      find("round").hidden = true;
      find("results").hidden = false;
      find("score").textContent = root.dataset.result
        .replace("%{score}", String(round.length - missed.length)).replace("%{total}", String(round.length));
      find("missed").replaceChildren();
      missed.forEach(verb => {
        const item = document.createElement("li");
        item.textContent = `${verb.base} / ${verb.past} / ${verb.participle}`;
        find("missed").append(item);
      });
      find("review").hidden = missed.length === 0;
      find("again").focus();
    });
  });
};

document.addEventListener("DOMContentLoaded", initIrregularVerbs);
document.addEventListener("turbo:load", initIrregularVerbs);
